import {Injectable} from '@angular/core';
import {DataTabs} from '../../shared/models/tabs-data';
import {GetShippingFormsService} from './get-shipping-forms.service';
import {GetConfigShippingService} from './get-config-shipping.service';

@Injectable({
  providedIn: 'root'
})
export class ShippingDataService {
  constructor(private getShippingFormsService: GetShippingFormsService,
              private getConfigShippingService: GetConfigShippingService) {
  }

  /*
  ATTENTION !! changer l'ordre impact la logic dans la page site detail (colonnes datatable et filter)
   */
  getShippingsListData(): DataTabs {
    return {
      dataTabs: [
        {
          titleTab: 'Shippings',
          contentTab: 'datatableShippingList',
          dataConfig: {
            form: this.getShippingFormsService.getFilterShippings(),
            groupConfigs: this.getConfigShippingService.getShippingsConfigs(),
            header : {
              icon: 'fal fa-shipping-fast',
              text: 'GENERIC_SHIPPINGS',
              rightSideButton : {
                buttonTitle : 'SHIPPINGS_NEW_TITLE',
                buttonIcon: 'fal fa-shipping-fast',
                action: 'link',
                href : ['/', 'shippings', 'add'],
                role: 'BO_SHIPPING_EDIT'
              },
            },
            content: [
              {
                name: 'GENERIC_TYPE',
                prop: 'type',
                sortable: true,
                array: [ { id : 1 , name : 'TYPE_OF_SHIPPING_RETURN'},
                         { id : 2 , name : 'TYPE_OF_SHIPPING_DEPLOY'},
                         { id : 4 , name : 'TYPE_OF_SHIPPING_EXCHANGE'},
                         { id : 5 , name : 'TYPE_OF_SHIPPING_EXTRA'},
                         { id : 6 , name : 'TYPE_OF_SHIPPING_TO_PTL'},
                         { id : 7 , name : 'TYPE_OF_SHIPPING_COLLECT_RETURN'},
                         { id: 8, name: 'TYPE_OF_SHIPPING_UPDATE_CD'}],
                type: 'array'
              },
              {
                name: 'TYPE_OF_SHIPPING_TRANSPORTER',
                prop: 'transporterName',
                sortable: true,
                type: 'text'
              },
              {
                name: 'ORDERS_LIST_SHIPPING_TRACKING',
                prop: 'tracking',
                sortable: true,
                type: 'externalTracking',
                path: 'trackingUrl'
              },
              {
                name: 'GENERIC_NAME',
                prop: 'displayName',
                sortable: true,
                type: 'shippingEdit', // used with action button for shipping and site->shipping
                path: 'shippingItem'
              },
              {
                name: 'TYPE_OF_SHIPPING_SITE_NAME',
                prop: 'siteName',
                sortable: true,
                type: 'routerLink',
                path: 'siteName'
              },
              {
                name: 'GENERIC_COUNTRY',
                prop: 'countryCode',
                sortable: true,
                type: 'country',
              },
              {
                name: 'ORDERS_LIST_PICKUP_DATE',
                prop: 'pickupDate',
                sortable: true,
                type: 'date'
              },
              {
                name: 'ORDERS_LIST_DELIVERY_DATE',
                prop: 'deliveryDate',
                sortable: true,
                type: 'date'
              },
              {
                name: 'GENERIC_STATUS',
                prop: 'deliveryStatus',
                sortable: true,
                type: 'text'
              },
              {
                name: 'GENERIC_ORDER',
                prop: 'orderName',
                sortable: true,
                type: 'routerLink',
                path: 'orderItem'
              },
            ]
          },
        }
      ]
    }
  }
}


